module.exports = __webpack_public_path__ + "img/img_14.edc8d9da.jpg";